module.exports = __webpack_public_path__ + "assets/img/ac83-zw.svg";